import React, { useCallback, useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';

const MIN_ROWS = 3;
const MAX_ROWS = 12;

// Multi-line textarea that grows with its content (MIN_ROWS..MAX_ROWS rows, then scrolls). Full width, user-resizable, line breaks kept as typed.
const AutoGrowTextarea = ({ value, className, ...rest }) => {
    const ref = useRef(null);
    const fit = useCallback(() => {
        const el = ref.current;
        if (!el) return;
        const style = window.getComputedStyle(el);
        const lineHeight = parseFloat(style.lineHeight) || (parseFloat(style.fontSize) || 16) * 1.5;
        const chrome = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0) + (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.borderBottomWidth) || 0);
        el.style.height = 'auto';
        const wanted = el.scrollHeight + (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.borderBottomWidth) || 0);
        el.style.height = `${Math.min(Math.max(wanted, lineHeight * MIN_ROWS + chrome), lineHeight * MAX_ROWS + chrome)}px`;
    }, []);
    useEffect(fit, [value, fit]);

    return <Form.Control as="textarea" ref={ref} rows={MIN_ROWS} value={value} className={`expense-description-input${className ? ` ${className}` : ''}`} {...rest} />;
};

export default AutoGrowTextarea;
